import { render, staticRenderFns } from "./EventObject.vue?vue&type=template&id=0b33d0df&"
import script from "./EventObject.vue?vue&type=script&lang=ts&"
export * from "./EventObject.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports